import parse, { attributesToProps, domToReact } from 'html-react-parser'
import Link from 'next/link'
interface Props {
  descriptionHtml: string
}
const ProductDetailsPDP = ({ descriptionHtml }: Props) => {
  const options = {
    replace: (domNode: any) => {
      if (domNode.name && domNode.name === 'a') {
        const props = attributesToProps(domNode.attribs)
        const modifyLink = (link: string) => {
          let originalLink = null
          try {
            originalLink = new URL(link)
          } catch (e) {
            return link
          }

          const queryString = originalLink.search
          const urlParams = new URLSearchParams(queryString)
          const keys = urlParams.keys()
          const updatedParams = new URLSearchParams()
          for (const key of keys) {
            if (key === 'p') {
              // If key is 'p', skip it to remove both key and value
              continue
            } else if (key.startsWith('refinementList[named_tags.colour]')) {
              // Replace 'refinementList[named_tags.colour]' with 'colour'
              const values = urlParams.getAll(key)
              values.forEach((value, index) => {
                updatedParams.append(`colour[${index}]`, value)
              })
            } else {
              // Keep other keys as they are
              updatedParams.set(key, urlParams.get(key) || '')
            }
          }
          // Construct the modified URL
          const modifiedLink =
            originalLink.origin +
            originalLink.pathname +
            '?' +
            updatedParams.toString()
          return modifiedLink
        }
        return (
          <Link
            {...props}
            href={modifyLink(props.href).replaceAll(
              'https://www.bauwerkcolour.com',
              ''
            )}
          >
            <>{domToReact(domNode.children, options)}</>
          </Link>
        )
      }
    },
  }
  return (
    <>
      <div className="wysiwyg body-1 mt-4 text-ui-dark-grey">
        {parse(descriptionHtml, options)}
      </div>
    </>
  )
}
export default ProductDetailsPDP
